/* Whitetail Hill — Mast Magnet landing page (wh-lp-*)
   One file drives: hero gallery + door swap, pack tiers (pack_tier blocks),
   sticky bar, singles box, cameras, buy-again. No dependencies.
   Every string comes from section/block settings via data-whlp-* JSON. */
(function () {
  'use strict';
  var W = (window.WHLP = window.WHLP || {});
  if (W.loaded) return; /* each LP section links this file; run once */
  W.loaded = true;

  /* ---------- helpers ---------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function readJSON(el) { if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function lc(s) { return String(s == null ? '' : s).trim().toLowerCase(); }
  function parseMap(txt) {
    var m = {};
    String(txt || '').split(/\r?\n/).forEach(function (line) {
      var i = line.indexOf('=');
      if (i > 0) m[lc(line.slice(0, i))] = line.slice(i + 1).trim();
    });
    return m;
  }
  function parseList(txt) { return String(txt || '').split(/[,\n]/).map(function (s) { return s.trim(); }).filter(Boolean); }
  function tpl(str, vars) {
    return String(str || '').replace(/\[(\w+)\]/g, function (m, k) { return Object.prototype.hasOwnProperty.call(vars, k) ? vars[k] : m; });
  }
  W.money = function (cents) {
    var fmt = String(W.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    var v = (cents || 0) / 100;
    function d(n, dec, th, sep) {
      var p = n.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p[0] + (p[1] ? sep + p[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return d(v, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return d(v, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return d(v, 0, '.', ',');
      return d(v, 2, ',', '.');
    });
  };
  function imgUrl(src, w) {
    if (!src) return '';
    if (typeof src === 'object') src = src.src || src.url || '';
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    src = src.replace(/([?&])width=\d+(&|$)/, function (m, a, b) { return b ? a : ''; });
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function variantImage(p, v) {
    if (v && v.featured_image) return v.featured_image.src || v.featured_image;
    /* if other variants have their own photos, a variant without one gets the labeled placeholder, never another flavor's photo */
    if (p && p.variants && p.variants.some(function (x) { return x.featured_image; })) return '';
    if (p && p.featured_image) return p.featured_image;
    if (p && p.images && p.images.length) return p.images[0];
    return '';
  }
  function optVals(v) { return v.options || [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }); }
  function findVariant(p, values) {
    if (!p || !p.variants) return null;
    for (var i = 0; i < p.variants.length; i++) {
      var o = optVals(p.variants[i]), ok = true;
      for (var j = 0; j < values.length; j++) if (o[j] !== values[j]) { ok = false; break; }
      if (ok) return p.variants[i];
    }
    return null;
  }
  /* closest variant when a combination doesn't exist: keep the option just changed, match as many others as possible */
  function closestVariant(p, values, keepIdx) {
    var best = null, score = -1;
    (p.variants || []).forEach(function (v) {
      var o = optVals(v);
      if (keepIdx != null && o[keepIdx] !== values[keepIdx]) return;
      var s = 0;
      for (var j = 0; j < values.length; j++) if (o[j] === values[j]) s++;
      if (v.available) s += 0.5;
      if (s > score) { score = s; best = v; }
    });
    return best;
  }
  /* a component's variant: has the flavor value, and (if given) a size value contained in sizeStr */
  function componentVariant(p, flavor, sizeStr) {
    if (!p || !p.variants || !flavor) return null;
    var f = lc(flavor), sz = lc(sizeStr), withFlavor = p.variants.filter(function (v) {
      return optVals(v).some(function (x) { return lc(x) === f; });
    });
    if (!withFlavor.length) return null;
    if (sz) {
      for (var i = 0; i < withFlavor.length; i++) {
        var o = optVals(withFlavor[i]);
        for (var j = 0; j < o.length; j++) if (lc(o[j]) !== f && sizeMatch(sz, o[j])) return withFlavor[i];
      }
    }
    return withFlavor[0];
  }
  /* '8 oz' matches 'L – 8 oz (flavors 500 lb)' and '4 × 8 lb' matches '8 lb', but '8 oz' never matches '18 oz' */
  function sizeMatch(a, b) {
    a = lc(a); b = lc(b);
    if (!a || !b) return false;
    function inside(needle, hay) {
      var i = hay.indexOf(needle);
      while (i > -1) {
        var before = i === 0 ? '' : hay.charAt(i - 1), after = hay.charAt(i + needle.length);
        if (!/[\d.]/.test(before) && !/[a-z\d]/.test(after)) return true;
        i = hay.indexOf(needle, i + 1);
      }
      return false;
    }
    return inside(a, b) || inside(b, a);
  }
  function componentSizeLabel(p, flavor, sizeStr) {
    var v = componentVariant(p, flavor, sizeStr);
    if (!v) return sizeStr || '';
    var f = lc(flavor), o = optVals(v);
    for (var j = 0; j < o.length; j++) if (lc(o[j]) !== f && sizeMatch(sizeStr, o[j])) return o[j];
    return sizeStr || '';
  }
  /* 'Dust (8 oz)' -> 'DUST (8 oz)': upper-case outside brackets so units stay readable */
  function upLabel(n) { return String(n).replace(/([^(]*)(\(.*\))?/, function (m, a, b) { return a.toUpperCase() + (b || ''); }); }
  function roleOf(name, overrides) {
    var o = overrides[lc(name)];
    if (o) return lc(o);
    var n = lc(name);
    if (n === 'title') return 'none'; /* single-variant product ("Default Title") */
    if (/dust/.test(n)) return 'dust';
    if (/cam|model/.test(n)) return 'camera';
    if (/size|weight|pack size/.test(n)) return 'size';
    return 'bag';
  }
  function firstAvailable(p) {
    if (!p || !p.variants) return null;
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) return p.variants[i];
    return p.variants[0] || null;
  }
  function findCamera(cams, value) {
    var v = lc(value);
    for (var i = 0; i < cams.length; i++) {
      var t = lc(cams[i].title);
      if (t && (t.indexOf(v) > -1 || v.indexOf(t) > -1)) return cams[i];
    }
    return null;
  }
  function placeholderHTML(root) {
    var t = root && $('[data-whlp-placeholder]', root);
    return t ? t.innerHTML : '';
  }
  function emit(name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail })); }
  function pixel(evt, ids, value, currency, cfg) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('whlp_' + evt.toLowerCase(), { content_ids: ids, value: value, currency: currency });
      }
      if (typeof window.fbq === 'function') {
        window.fbq('track', evt, { content_ids: ids, content_type: 'product', value: value, currency: currency });
      }
    } catch (e) { /* never block the cart on tracking */ }
  }
  function contentId(cfg, productId, variantId) {
    return tpl(cfg.pixel_id_format || 'shopify_[country]_[product]_[variant]', { country: W.country || 'US', product: productId, variant: variantId });
  }

  /* ---------- cart ---------- */
  function drawerUsable() {
    var d = document.getElementById('CartDrawer');
    if (!d) return false;
    /* the drawer itself is display:none while closed in Impulse, so only its ancestors are checked */
    for (var el = d.parentElement; el && el !== document.body; el = el.parentElement) {
      if (getComputedStyle(el).display === 'none') return false;
    }
    return true;
  }
  W.addToCart = function (items, opts) {
    opts = opts || {};
    var btn = opts.button, errEl = opts.errorEl, label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); if (opts.addingText) btn.textContent = opts.addingText; }
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    return fetch((W.routes && W.routes.cart_add) ? W.routes.cart_add + '.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    }).then(function (res) {
      if (opts.onAdded) opts.onAdded(res);
      var mode = opts.after || 'drawer', root = ((W.routes && W.routes.root) || '/').replace(/\/?$/, '/');
      if (mode === 'shoppay') { location.href = root + 'checkout?payment=shop_pay'; return; }
      if (mode === 'checkout') { location.href = root + 'checkout'; return; }
      if (mode === 'cart' || !drawerUsable()) { location.href = (W.routes && W.routes.cart) || '/cart'; return; }
      /* Impulse 8: cart:build re-renders the drawer from /cart.js, cart:open opens it */
      emit('cart:build');
      emit('ajaxProduct:added', { product: res.items ? res.items[0] : res, addToCartBtn: btn });
      setTimeout(function () {
        var d0 = document.getElementById('CartDrawer');
        if (d0 && !/is-open/.test(d0.className)) emit('cart:open');
      }, 150);
      setTimeout(function () {
        var d = document.getElementById('CartDrawer');
        if (d && !/is-open/.test(d.className)) {
          if (window.theme && theme.CartDrawer && typeof theme.CartDrawer.open === 'function') theme.CartDrawer.open();
          else location.href = (W.routes && W.routes.cart) || '/cart';
        }
      }, 700);
    }).catch(function (err) {
      if (errEl) { errEl.textContent = (err && (err.description || err.message)) || 'Could not add to cart. Please try again.'; errEl.hidden = false; }
    }).then(function () {
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = label; if (opts.refresh) opts.refresh(); }
    });
  };

  /* ---------- swatch / pill markup ---------- */
  function swatchHTML(i, val, on, color, short) {
    return '<button type="button" class="whlp-sw" data-opt="' + i + '" data-val="' + esc(val) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
      '<span class="whlp-sw__bar" style="background:' + esc(color || 'var(--whlp-border)') + '"></span>' +
      '<span class="whlp-sw__txt">' + esc(short) + '</span></button>';
  }
  function pillHTML(i, val, on, main, price, sub) {
    return '<button type="button" class="whlp-pill" data-opt="' + i + '" data-val="' + esc(val) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
      '<span class="whlp-pill__main">' + esc(main) + '</span>' +
      (price ? '<span class="whlp-pill__price">' + esc(price) + '</span>' : '') +
      (sub ? '<span class="whlp-pill__sub">' + esc(sub) + '</span>' : '') + '</button>';
  }
  function restoreFocus(container, key) {
    if (!key) return;
    var b = container.querySelector('[data-opt="' + key.opt + '"][data-val="' + (window.CSS && CSS.escape ? CSS.escape(key.val) : key.val) + '"]');
    if (b) b.focus({ preventScroll: true });
  }

  /* =====================================================================
     BUY BOX (hero + pack tiers + sticky)
     ===================================================================== */
  function Buy(root) {
    var cfg = readJSON($('[data-whlp-buy-config]', root)) || {};
    this.root = root;
    this.cfg = cfg;
    this.colors = parseMap(cfg.swatch_colors);
    this.shorts = parseMap(cfg.short_names);
    this.longs = parseMap(cfg.long_names);
    this.mm = cfg.mm_product || null;
    this.dust = cfg.dust_product || null;
    this.cams = (cfg.cameras || []).filter(Boolean);
    this.threshold = Math.round(parseFloat(cfg.free_ship_threshold || 0) * 100);
    var self = this;
    this.tiers = $$('[data-whlp-tier]', root).map(function (el, idx) { return self.initTier(el, idx); });
    var def = this.tiers.filter(function (t) { return t.cfg.default_selected; })[0] || this.tiers[Math.floor((this.tiers.length - 1) / 2)] || this.tiers[0];
    this.sel = def ? def.idx : 0;
    this.atc = $('[data-whlp-atc]', root);
    this.shop = $('[data-whlp-shoppay]', root);
    this.ship = $('[data-whlp-ship]', root);
    this.err = $('[data-whlp-error]', root);
    this.sticky = $('[data-whlp-sticky]', root);

    root.addEventListener('click', function (e) {
      var head = e.target.closest('[data-whlp-tier-pick]');
      if (head) { self.select(+head.getAttribute('data-whlp-tier-pick')); return; }
      var b = e.target.closest('[data-opt]');
      if (b && root.contains(b)) {
        var tierEl = b.closest('[data-whlp-tier]');
        if (tierEl) self.pickOption(+tierEl.getAttribute('data-idx'), b.getAttribute('data-opt'), b.getAttribute('data-val'));
      }
    });
    if (this.atc) this.atc.addEventListener('click', function () { self.add(cfg.after_add || 'drawer', self.atc); });
    if (this.shop) this.shop.addEventListener('click', function () { self.add('shoppay', self.shop); });
    if (this.sticky) {
      var sb = $('[data-whlp-sticky-atc]', this.sticky);
      if (sb) sb.addEventListener('click', function () { self.add(cfg.after_add || 'drawer', sb); });
      this.initSticky();
    }
    W.buy = this;
    this.render();
    if (cfg.pixel_view_content) {
      var t = this.current();
      if (t && t.variant) pixel('ViewContent', [contentId(cfg, t.product.id, t.variant.id)], t.variant.price / 100, W.currency, cfg);
    }
  }
  Buy.prototype.short = function (v) { return this.shorts[lc(v)] || v; };
  Buy.prototype.long = function (v) { return this.longs[lc(v)] || v; };
  Buy.prototype.color = function (v) { return this.colors[lc(v)] || ''; };

  Buy.prototype.initTier = function (el, idx) {
    var c = readJSON($('[data-whlp-tier-config]', el)) || {};
    el.setAttribute('data-idx', idx);
    var head = $('[data-whlp-tier-head]', el);
    if (head) head.setAttribute('data-whlp-tier-pick', idx);
    var t = { el: el, idx: idx, cfg: c, product: c.product || null, labels: parseMap(c.option_label_overrides), dustMap: parseMap(c.dust_match_map),
      roles: [], values: [], dustTouched: false, variant: null, camIdx: 0 };
    var roleOv = parseMap(c.option_roles), defaults = parseMap(c.default_values);
    if (t.product && t.product.options) {
      var opts = t.product.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
      t.optNames = opts;
      t.roles = opts.map(function (n) { return roleOf(n, roleOv); });
      var v0 = (c.selected_variant_id && t.product.variants.filter(function (v) { return v.id === c.selected_variant_id; })[0]) || firstAvailable(t.product);
      t.values = v0 ? optVals(v0).slice() : [];
      opts.forEach(function (n, i) { if (defaults[lc(n)]) t.values[i] = defaults[lc(n)]; });
      this.syncDust(t);
      t.variant = findVariant(t.product, t.values) || closestVariant(t.product, t.values, null);
      if (t.variant) t.values = optVals(t.variant).slice();
    }
    return t;
  };
  Buy.prototype.syncDust = function (t) {
    if (t.dustTouched || !t.product) return;
    var bagIdx = t.roles.indexOf('bag'), bagVal;
    if (bagIdx > -1) bagVal = t.values[bagIdx];
    else if (t.cfg.fixed_bags) bagVal = parseList(t.cfg.fixed_bags)[0];
    if (!bagVal) return;
    var target = t.dustMap[lc(bagVal)];
    if (!target) return;
    var self = this;
    t.roles.forEach(function (r, i) {
      if (r !== 'dust') return;
      var vals = self.optionValues(t, i);
      var hit = vals.filter(function (v) { return lc(v) === lc(target); })[0];
      if (hit) t.values[i] = hit;
    });
  };
  Buy.prototype.optionValues = function (t, i) {
    var seen = {}, out = [];
    (t.product.variants || []).forEach(function (v) { var x = optVals(v)[i]; if (x != null && !seen[x]) { seen[x] = 1; out.push(x); } });
    return out;
  };
  Buy.prototype.pickOption = function (idx, opt, val) {
    var t = this.tiers[idx];
    if (!t) return;
    if (opt === 'cam') { t.camIdx = +val; this.render({ opt: opt, val: val }, idx); return; }
    var i = +opt;
    t.values[i] = val;
    if (t.roles[i] === 'dust') t.dustTouched = true;
    if (t.roles[i] === 'bag' && t.roles.indexOf('bag') === i) this.syncDust(t);
    t.variant = findVariant(t.product, t.values) || closestVariant(t.product, t.values, i);
    if (t.variant) t.values = optVals(t.variant).slice();
    if (this.sel !== idx) this.sel = idx;
    this.render({ opt: opt, val: val }, idx);
  };
  Buy.prototype.select = function (idx) {
    if (!this.tiers[idx]) return;
    this.sel = idx;
    this.render();
    var self = this;
    // keep the opened card in view on small screens
    var el = this.tiers[idx].el;
    if (el.getBoundingClientRect().top < 0) el.scrollIntoView({ block: 'start', behavior: 'smooth' });
    void self;
  };
  Buy.prototype.current = function () { return this.tiers[this.sel]; };
  Buy.prototype.camera = function (t) {
    if (!t.cfg.camera_line || !this.cams.length) return null;
    return this.cams[t.camIdx] || this.cams[0];
  };
  /* returns {cents, known, text} for a tier's current pick */
  Buy.prototype.priceOf = function (t) {
    if (!t.variant) return { cents: 0, known: false, text: t.cfg.fallback_price || '' };
    var cents = t.variant.price, known = true, text;
    var cam = this.camera(t);
    if (t.cfg.camera_line) {
      var cv = cam && firstAvailable(cam);
      if (cv) cents += cv.price; else known = false;
    }
    text = known ? W.money(cents) : tpl(this.cfg.cam_unknown_tpl || '[price] + cam', { price: W.money(cents) });
    return { cents: cents, known: known, text: text };
  };
  Buy.prototype.shipText = function (cents) {
    var gap = this.threshold - cents;
    if (this.threshold && gap > 0) return tpl(this.cfg.ship_gap_msg, { amount: W.money(gap) });
    return this.cfg.ship_free_msg || '';
  };
  Buy.prototype.priceSub = function (t, p) {
    var mode = t.cfg.price_sub_mode || 'auto';
    if (mode === 'none') return '';
    if (!t.variant && mode === 'auto') return '';
    if (mode === 'fixed') return t.cfg.price_sub || '';
    var gap = this.threshold - p.cents;
    if (this.threshold && gap > 0) return tpl(this.cfg.price_sub_auto || '[amount] to free shipping', { amount: W.money(gap) });
    return this.cfg.price_sub_free || '';
  };
  Buy.prototype.thumbs = function (t) {
    var self = this, out = [], sizeIdx = t.roles.indexOf('size');
    var sizeStr = sizeIdx > -1 ? t.values[sizeIdx] : (t.cfg.bag_size || '');
    var lbl = this.cfg.thumb_label || '[size] · [name]';
    function bag(flavor) {
      var cv = componentVariant(self.mm, flavor, sizeStr);
      out.push({ img: cv ? variantImage(self.mm, cv) : '', color: self.color(flavor),
        label: tpl(lbl, { size: componentSizeLabel(self.mm, flavor, sizeStr), name: self.short(flavor) }) });
    }
    var dustVal = null;
    t.roles.forEach(function (r, i) { if (r === 'bag') bag(t.values[i]); });
    parseList(t.cfg.fixed_bags).forEach(bag);
    t.roles.forEach(function (r, i) {
      if (r !== 'dust') return;
      dustVal = dustVal || t.values[i];
      var cv = componentVariant(self.dust, t.values[i], t.cfg.dust_size);
      out.push({ img: cv ? variantImage(self.dust, cv) : '', color: self.color(t.values[i]),
        label: tpl(lbl, { size: t.cfg.dust_size || '', name: self.short(t.values[i]) }) });
    });
    parseList(t.cfg.fixed_dusts).forEach(function (f) {
      dustVal = dustVal || f;
      var cv = componentVariant(self.dust, f, t.cfg.dust_size);
      out.push({ img: cv ? variantImage(self.dust, cv) : '', color: self.color(f),
        label: tpl(lbl, { size: t.cfg.dust_size || '', name: self.short(f) }) });
    });
    if (t.cfg.bonus_thumb_size) {
      var bv = dustVal || (self.dust && self.dust.variants && optVals(self.dust.variants[0])[0]);
      var cv = componentVariant(self.dust, bv, t.cfg.bonus_thumb_size);
      out.push({ img: cv ? variantImage(self.dust, cv) : '', color: self.color(bv),
        label: tpl(lbl, { size: tpl(t.cfg.bonus_thumb_label || 'FREE [size]', { size: t.cfg.bonus_thumb_size }), name: self.short(bv) }) });
    }
    t.roles.forEach(function (r, i) {
      if (r !== 'camera') return;
      var cam = findCamera(self.cams, t.values[i]);
      out.push({ img: cam ? variantImage(cam, firstAvailable(cam)) : '', color: '#ffffff', label: t.values[i] });
    });
    if (t.cfg.extra_thumb || t.cfg.extra_thumb_label) out.push({ img: t.cfg.extra_thumb || '', color: '#ffffff', label: t.cfg.extra_thumb_label || '' });
    var lc_ = this.camera(t);
    if (lc_) out.push({ img: variantImage(lc_, firstAvailable(lc_)), color: '#ffffff', label: lc_.title });
    return out;
  };
  Buy.prototype.bodyHTML = function (t) {
    var self = this, h = '';
    if (!t.product) return '<p class="whlp-tier__empty">' + esc(t.cfg.empty_note || '') + '</p>';
    if (t.cfg.thumbnails) {
      h += '<div class="whlp-thumbs">';
      this.thumbs(t).forEach(function (th) {
        h += '<div class="whlp-thumb">' + (th.img ? '<img src="' + esc(imgUrl(th.img, 140)) + '" alt="" loading="lazy" width="62" height="62">' :
          '<span class="whlp-thumb__bar" style="background:' + esc(th.color || '#ffffff') + '"></span>') +
          '<span class="whlp-thumb__lbl">' + esc(th.label) + '</span></div>';
      });
      h += '</div>';
    }
    var firstBag = t.roles.indexOf('bag');
    t.roles.forEach(function (role, i) {
      if (role === 'none') return;
      var name = t.optNames[i], vals = self.optionValues(t, i);
      if (vals.length < 2 && role !== 'dust') return; // nothing to choose
      var label = t.labels[lc(name)] || (upLabel(name) + ':');
      var cur = t.values[i], note = '';
      if (role === 'dust' && !t.dustTouched) {
        var bagVal = firstBag > -1 ? t.values[firstBag] : parseList(t.cfg.fixed_bags)[0];
        if (bagVal && t.dustMap[lc(bagVal)]) {
          /* 'closest' only when Dust stands in with a different bag flavor (Pear → Apple); Original → Persimmon Nut is the same scent */
          var target = lc(t.dustMap[lc(bagVal)]);
          var bagFlavors = firstBag > -1 ? self.optionValues(t, firstBag).map(lc) : parseList(t.cfg.fixed_bags).map(lc);
          var closest = target !== lc(bagVal) && bagFlavors.indexOf(target) > -1;
          note = closest ? tpl(self.cfg.dust_note_closest || '', { flavor: self.short(bagVal) }) : (self.cfg.dust_note_matched || '');
        }
      }
      h += '<div class="whlp-opt"><div class="whlp-opt__label"><span class="whlp-opt__name">' + esc(label) + '</span> ' + esc(role === 'size' || role === 'camera' || role === 'dust' ? self.short(cur) : self.long(cur)) +
        (note ? ' <span class="whlp-opt__note">' + esc(note) + '</span>' : '') + '</div>';
      if (role === 'size' || role === 'camera') {
        h += '<div class="whlp-grid" style="--whlp-cols:' + Math.min(vals.length, 3) + '">';
        vals.forEach(function (v) {
          var vv = t.values.slice(); vv[i] = v;
          var variant = findVariant(t.product, vv) || closestVariant(t.product, vv, i), price = '';
          if (role === 'camera') {
            var cam = findCamera(self.cams, v), cv = cam && firstAvailable(cam);
            price = cv ? W.money(cv.price) : (self.cfg.camera_price_placeholder || '');
          } else if (variant) price = W.money(variant.price);
          h += pillHTML(i, v, v === cur, self.short(v), price, '');
        });
      } else {
        h += '<div class="whlp-grid" style="--whlp-cols:' + Math.min(vals.length, 4) + '">';
        vals.forEach(function (v) { h += swatchHTML(i, v, v === cur, self.color(v), self.short(v)); });
      }
      h += '</div></div>';
    });
    var cam = this.camera(t);
    if (cam) {
      h += '<div class="whlp-opt"><div class="whlp-opt__label"><span class="whlp-opt__name">' + esc(t.cfg.camera_label || 'CAMERA:') + '</span> ' + esc(cam.title) + '</div>' +
        '<div class="whlp-grid" style="--whlp-cols:' + Math.min(this.cams.length, 3) + '">';
      this.cams.forEach(function (c, ci) {
        var cv = firstAvailable(c);
        h += pillHTML('cam', String(ci), c === cam, c.title, cv ? W.money(cv.price) : (self.cfg.camera_price_placeholder || ''), '');
      });
      h += '</div></div>';
    }
    return h;
  };
  /* card photo: pack photo setting > bundle variant photo > bag + shaker in the picked flavors (up to 2, camera replaces the shaker) > section Mast Magnet photo */
  Buy.prototype.tierImgs = function (t) {
    if (t.cfg.image) return [t.cfg.image];
    if (t.variant && t.variant.featured_image) return [variantImage(t.product, t.variant)];
    var th = t.product ? this.thumbs(t).filter(function (x) { return x.img; }) : [];
    if (th.length) {
      var cam = th.filter(function (x) { return x.color === '#ffffff'; })[0];
      var first = th[0], second = cam || th.filter(function (x) { return x !== first && /oz/i.test(x.label); })[0] || th[1];
      return [first.img].concat(second && second !== first ? [second.img] : []);
    }
    if (t.product && t.product.featured_image) return [t.product.featured_image];
    var out = [];
    if (this.mm) out.push(variantImage(this.mm, firstAvailable(this.mm)) || this.mm.featured_image);
    if (this.dust && /dust|\+/i.test((t.cfg.contents || '') + (t.cfg.name || ''))) out.push(variantImage(this.dust, firstAvailable(this.dust)) || this.dust.featured_image);
    return out.filter(Boolean);
  };
  Buy.prototype.paintTierImg = function (t, el) {
    var imgs = this.tierImgs(t), key = imgs.join('|');
    if (!imgs.length || el.getAttribute('data-key') === key) return;
    el.setAttribute('data-key', key);
    el.classList.toggle('is-pair', imgs.length > 1);
    el.innerHTML = imgs.slice(0, 2).map(function (src, i) {
      return '<img src="' + esc(imgUrl(src, i ? 100 : 160)) + '" alt="" width="56" height="56" class="whlp-tier__img' + (i ? '2' : '1') + '">';
    }).join('');
  };
  Buy.prototype.flavorSummary = function (t) {
    var self = this, bags = [], dusts = [], cams = [];
    t.roles.forEach(function (r, i) {
      if (r === 'bag') bags.push(self.short(t.values[i]));
      else if (r === 'dust') dusts.push(self.short(t.values[i]));
      else if (r === 'camera') cams.push(t.values[i]);
      else if (r === 'size') bags.push(t.values[i]);
    });
    if (!bags.length && t.cfg.fixed_bags) bags.push(t.cfg.fixed_bags_summary || parseList(t.cfg.fixed_bags).map(function (b) { return self.short(b); }).join(' + '));
    if (!dusts.length && t.cfg.fixed_dusts) dusts.push(parseList(t.cfg.fixed_dusts).map(function (b) { return self.short(b); }).join(' + '));
    var cam = this.camera(t);
    if (cam) cams.push(cam.title);
    return { bags: bags.join(' + '), dust: dusts.join(' + '), camera: cams.join(' + ') };
  };
  Buy.prototype.render = function (focusKey, focusIdx) {
    var self = this;
    this.tiers.forEach(function (t) {
      var on = t.idx === self.sel, p = self.priceOf(t);
      t.el.classList.toggle('is-on', on);
      var head = $('[data-whlp-tier-head]', t.el);
      if (head) head.setAttribute('aria-pressed', on ? 'true' : 'false');
      var pe = $('[data-whlp-tier-price]', t.el); if (pe) pe.textContent = p.text;
      var cmp = $('[data-whlp-tier-compare]', t.el);
      if (cmp) { var ca = t.variant && t.variant.compare_at_price > t.variant.price ? W.money(t.variant.compare_at_price) : ''; cmp.textContent = ca; cmp.hidden = !ca; }
      var se = $('[data-whlp-tier-sub]', t.el); if (se) se.textContent = self.priceSub(t, p);
      var ie = $('[data-whlp-tier-img]', t.el); if (ie) self.paintTierImg(t, ie);
      var body = $('[data-whlp-tier-body]', t.el);
      if (body) {
        body.hidden = !on;
        if (on) { body.innerHTML = self.bodyHTML(t); if (focusIdx === t.idx) restoreFocus(body, focusKey); }
        else body.innerHTML = '';
      }
    });
    var t = this.current(), p = t ? this.priceOf(t) : { cents: 0, text: '' };
    var avail = t && t.variant && t.variant.available;
    var totalTxt = p.text;
    if (this.atc) {
      this.atc.disabled = !avail;
      this.atc.textContent = avail ? tpl(this.cfg.atc_label, { total: totalTxt }) : (t && t.variant ? this.cfg.atc_soldout : this.cfg.atc_unset);
    }
    if (this.shop) this.shop.disabled = !avail;
    if (this.ship) this.ship.textContent = t && t.variant ? this.shipText(p.cents) : '';
    var fs = t ? this.flavorSummary(t) : { bags: '', dust: '', camera: '' };
    var state = {
      tierName: t ? (t.cfg.name || '') : '', total: totalTxt, available: !!avail, ship: this.ship ? this.ship.textContent : '',
      shipsFree: this.threshold && p.cents >= this.threshold, bags: fs.bags, dust: fs.dust, camera: fs.camera,
      tiers: this.tiers.map(function (x) { return { idx: x.idx, name: x.cfg.short_name || x.cfg.name, price: self.priceOf(x).text, on: x.idx === self.sel }; })
    };
    this.state = state;
    if (this.sticky) {
      var lab = $('[data-whlp-sticky-label]', this.sticky), pr = $('[data-whlp-sticky-price]', this.sticky), sb = $('[data-whlp-sticky-atc]', this.sticky);
      if (lab) lab.textContent = tpl(this.cfg.sticky_label_tpl, { tier: state.tierName, bags: state.bags, dust: state.dust, camera: state.camera });
      if (pr) pr.innerHTML = '<span class="whlp-sticky__amt">' + esc(totalTxt) + '</span>' + (state.shipsFree && this.cfg.sticky_ship_free ? ' · ' + esc(this.cfg.sticky_ship_free) : '');
      if (sb) sb.disabled = !avail;
    }
    emit('whlp:change', state);
  };
  Buy.prototype.items = function () {
    var t = this.current();
    if (!t || !t.variant) return [];
    var items = [{ id: t.variant.id, quantity: 1 }];
    var cam = this.camera(t), cv = cam && firstAvailable(cam);
    if (cv) items.push({ id: cv.id, quantity: 1 });
    return items;
  };
  Buy.prototype.add = function (mode, btn) {
    var self = this, items = this.items(), t = this.current();
    if (!items.length) return;
    W.addToCart(items, {
      button: btn, errorEl: this.err, addingText: this.cfg.atc_adding, after: mode,
      onAdded: function () {
        if (self.cfg.pixel_atc) pixel('AddToCart', [contentId(self.cfg, t.product.id, t.variant.id)], self.priceOf(t).cents / 100, W.currency, self.cfg);
        emit('whlp:added', { items: items });
      },
      refresh: function () { self.render(); }
    });
  };
  Buy.prototype.initSticky = function () {
    var self = this, bar = this.sticky, target = $('[data-whlp-buy-anchor]', this.root) || this.atc;
    if (!target || !('IntersectionObserver' in window)) return;
    var buyVisible = true, againVisible = false;
    function update() {
      var show = !buyVisible && !againVisible && target.getBoundingClientRect().top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      $$('button', bar).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
    }
    new IntersectionObserver(function (e) { buyVisible = e[0].isIntersecting; update(); }).observe(target);
    var again = document.querySelector('[data-whlp-again]');
    if (again) new IntersectionObserver(function (e) { againVisible = e[0].isIntersecting; update(); }).observe(again);
    window.addEventListener('scroll', function () { if (!buyVisible) update(); }, { passive: true });
    update();
    void self;
  };

  /* ---------- hero gallery + door ---------- */
  function initGallery(root) {
    var track = $('[data-whlp-gallery-track]', root);
    if (!track) return;
    var gal = track.closest('.whlp-gallery') || root;
    var slides = $$('[data-whlp-slide]', track).filter(function (s) { return !s.hidden; });
    var count = $('[data-whlp-gallery-count]', root), dots = $('[data-whlp-gallery-dots]', root);
    var prev = $('[data-whlp-gallery-prev]', root), next = $('[data-whlp-gallery-next]', root);
    if (dots) dots.innerHTML = slides.map(function (s, i) { return '<span class="whlp-dot' + (i ? '' : ' is-on') + '"></span>'; }).join('');
    function cur() { return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth)))); }
    function upd() {
      var i = cur();
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      if (dots) $$('.whlp-dot', dots).forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
    }
    function go(i) {
      var n = slides.length;
      i = ((i % n) + n) % n; /* wrap around both ways */
      track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    upd();
    if (slides.length < 2) {
      if (count) count.hidden = true;
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
    }

    /* ---- autoplay: every N seconds (section setting), per-slide override; pauses on touch/hover, off screen, hidden tab, reduced motion ---- */
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var secs = parseFloat(gal.getAttribute('data-autoplay') || '0');
    var resumeAfter = parseFloat(gal.getAttribute('data-resume') || '6') * 1000;
    var timer = null, visible = true, hovering = false, heldUntil = 0;
    function delayFor(i) {
      var o = parseFloat(slides[i] && slides[i].getAttribute('data-seconds'));
      return (o > 0 ? o : secs) * 1000;
    }
    function schedule() {
      clearTimeout(timer);
      if (!(secs > 0) || reduce || slides.length < 2 || !visible || hovering || document.hidden) return;
      var wait = Math.max(delayFor(cur()), heldUntil - Date.now());
      timer = setTimeout(function () { go(cur() + 1); schedule(); }, wait);
    }
    function userMoved() { heldUntil = Date.now() + resumeAfter; schedule(); }
    if (prev) prev.addEventListener('click', function () { go(cur() - 1); userMoved(); });
    if (next) next.addEventListener('click', function () { go(cur() + 1); userMoved(); });
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { track.addEventListener(ev, userMoved, { passive: true }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(cur() + 1); userMoved(); }
      if (e.key === 'ArrowLeft') { go(cur() - 1); userMoved(); }
    });
    gal.addEventListener('mouseenter', function () { hovering = true; schedule(); });
    gal.addEventListener('mouseleave', function () { hovering = false; schedule(); });
    gal.addEventListener('focusin', function () { hovering = true; schedule(); });
    gal.addEventListener('focusout', function () { hovering = false; schedule(); });
    document.addEventListener('visibilitychange', schedule);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { visible = e[0].isIntersecting; schedule(); }, { threshold: 0.3 }).observe(gal);
      $$('video', track).forEach(function (v) {
        v.muted = true;
        new IntersectionObserver(function (e) {
          if (e[0].isIntersecting) { try { v.currentTime = 0; } catch (x) {} var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
        }, { threshold: 0.6 }).observe(v);
      });
    }
    schedule();
  }
  W.applyDoor = function (scope, param) {
    var door = 'mast';
    try { door = new URLSearchParams(location.search).get(param || 'door') || 'mast'; } catch (e) {}
    door = lc(door);
    $$('[data-whlp-door]', scope || document).forEach(function (el) {
      var d = el.getAttribute('data-whlp-door');
      if (d === 'all') return;
      var match = d === door || (d === 'mast' && door !== 'dust');
      el.hidden = !match;
    });
    document.documentElement.setAttribute('data-whlp-door', door === 'dust' ? 'dust' : 'mast');
  };

  /* =====================================================================
     SINGLES
     ===================================================================== */
  function Singles(root) {
    var cfg = readJSON($('[data-whlp-singles-config]', root)) || {};
    var buyCfg = (W.buy && W.buy.cfg) || {};
    this.root = root; this.cfg = cfg;
    this.colors = parseMap(cfg.swatch_colors || buyCfg.swatch_colors);
    this.shorts = parseMap(cfg.short_names || buyCfg.short_names);
    this.longs = parseMap(cfg.long_names || buyCfg.long_names);
    this.subs = parseMap(cfg.size_sublabels);
    this.threshold = Math.round(parseFloat(cfg.free_ship_threshold || 0) * 100);
    this.tabs = (cfg.tabs || []).filter(function (x) { return x && x.product; }).map(function (x) {
      var v = firstAvailable(x.product), values = v ? optVals(v).slice() : [], dv = parseMap(x.default_values);
      (x.product.options || []).forEach(function (o, i) { var n = typeof o === 'string' ? o : o.name; if (dv[lc(n)]) values[i] = dv[lc(n)]; });
      var hit = findVariant(x.product, values);
      if (hit) v = hit;
      return { product: x.product, url: x.url, values: v ? optVals(v).slice() : [], variant: v };
    });
    this.tab = 0;
    var self = this;
    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-whlp-tab]');
      if (tab) { self.tab = +tab.getAttribute('data-whlp-tab'); self.render(); return; }
      var b = e.target.closest('[data-opt]');
      if (b) self.pick(+b.getAttribute('data-opt'), b.getAttribute('data-val'), b);
    });
    this.atc = $('[data-whlp-singles-atc]', root);
    this.err = $('[data-whlp-error]', root);
    if (this.atc) this.atc.addEventListener('click', function () {
      var tb = self.tabs[self.tab];
      if (!tb || !tb.variant) return;
      W.addToCart([{ id: tb.variant.id, quantity: 1 }], { button: self.atc, errorEl: self.err, addingText: cfg.atc_adding, after: cfg.after_add,
        onAdded: function () { if (cfg.pixel_atc) pixel('AddToCart', [contentId(cfg, tb.product.id, tb.variant.id)], tb.variant.price / 100, W.currency, cfg); },
        refresh: function () { self.render(); } });
    });
    this.render();
  }
  Singles.prototype.pick = function (i, val, btn) {
    var tb = this.tabs[this.tab];
    tb.values[i] = val;
    tb.variant = findVariant(tb.product, tb.values) || closestVariant(tb.product, tb.values, i);
    if (tb.variant) tb.values = optVals(tb.variant).slice();
    this.render({ opt: String(i), val: val });
  };
  Singles.prototype.render = function (focusKey) {
    var self = this, cfg = this.cfg, tb = this.tabs[this.tab];
    $$('[data-whlp-tab]', this.root).forEach(function (b) {
      var on = +b.getAttribute('data-whlp-tab') === self.tab;
      b.setAttribute('aria-selected', on ? 'true' : 'false'); b.classList.toggle('is-on', on);
    });
    var body = $('[data-whlp-singles-body]', this.root), media = $('[data-whlp-singles-media]', this.root);
    if (!tb) { if (body) body.innerHTML = '<p class="whlp-tier__empty">' + esc(cfg.empty_note || '') + '</p>'; if (this.atc) this.atc.disabled = true; return; }
    var p = tb.product, opts = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var roleOv = parseMap(cfg.option_roles), h = '', labelOv = parseMap(cfg.option_label_overrides);
    opts.forEach(function (name, i) {
      var role = roleOf(name, roleOv);
      var seen = {}, vals = [];
      p.variants.forEach(function (v) { var x = optVals(v)[i]; if (x != null && !seen[x]) { seen[x] = 1; vals.push(x); } });
      if (vals.length < 2) return;
      var cur = tb.values[i];
      var label = labelOv[lc(name)] || (upLabel(name) + (role === 'size' ? '' : ':'));
      h += '<div class="whlp-opt"><div class="whlp-opt__label"><span class="whlp-opt__name">' + esc(label) + '</span>' + (role === 'size' ? '' : ' ' + esc(self.longs[lc(cur)] || cur)) + '</div>';
      if (role === 'size') {
        h += '<div class="whlp-grid" style="--whlp-cols:' + Math.min(vals.length, 3) + '">';
        vals.forEach(function (v) {
          var vv = tb.values.slice(); vv[i] = v;
          var vr = findVariant(p, vv) || closestVariant(p, vv, i);
          h += pillHTML(i, v, v === cur, self.shorts[lc(v)] || v, vr ? W.money(vr.price) : '', self.subs[lc(v)] || '');
        });
      } else {
        h += '<div class="whlp-grid" style="--whlp-cols:' + Math.min(vals.length, 4) + '">';
        vals.forEach(function (v) { h += swatchHTML(i, v, v === cur, self.colors[lc(v)] || '', self.shorts[lc(v)] || v); });
      }
      h += '</div></div>';
    });
    if (body) { body.innerHTML = h; if (focusKey) restoreFocus(body, focusKey); }
    if (media) {
      var src = variantImage(p, tb.variant);
      var label = tpl(cfg.image_label_tpl || '[title] · [variant]', { title: p.title, variant: tb.variant ? tb.variant.title : '' });
      media.innerHTML = src ? '<img src="' + esc(imgUrl(src, 720)) + '" alt="' + esc(label) + '" width="360" height="360">' :
        '<div class="whlp-ph">' + placeholderHTML(this.root) + '<span class="whlp-ph__lbl">' + esc(tpl(cfg.placeholder_label || 'Product photo: [label]', { label: label })) + '</span></div>';
    }
    var det = $('[data-whlp-singles-details]', this.root);
    if (det && tb.url) det.setAttribute('href', tb.url + (tb.variant ? '?variant=' + tb.variant.id : ''));
    var avail = tb.variant && tb.variant.available;
    if (this.atc) { this.atc.disabled = !avail; this.atc.textContent = avail ? tpl(cfg.atc_label, { total: W.money(tb.variant.price) }) : cfg.atc_soldout; }
    var ship = $('[data-whlp-ship]', this.root);
    if (ship && tb.variant) {
      var gap = this.threshold - tb.variant.price;
      ship.textContent = this.threshold && gap > 0 ? tpl(cfg.ship_gap_msg, { amount: W.money(gap) }) : cfg.ship_free_msg;
    }
  };

  /* =====================================================================
     CAMERAS
     ===================================================================== */
  function Cams(root) {
    var cfg = readJSON($('[data-whlp-cams-config]', root)) || {};
    this.root = root; this.cfg = cfg; this.sel = 0;
    this.cards = $$('[data-whlp-cam]', root);
    this.accs = $$('[data-whlp-acc]', root);
    this.atc = $('[data-whlp-cams-atc]', root);
    this.err = $('[data-whlp-error]', root);
    var self = this;
    this.cards.forEach(function (c, i) {
      if (c.getAttribute('data-default') === 'true') self.sel = i;
      c.addEventListener('click', function () { self.sel = i; self.render(); });
    });
    this.accs.forEach(function (a) { var cb = $('input', a); if (cb) cb.addEventListener('change', function () { self.render(); }); });
    if (this.atc) this.atc.addEventListener('click', function () {
      var items = self.items();
      if (!items.length) return;
      W.addToCart(items, { button: self.atc, errorEl: self.err, addingText: cfg.atc_adding, after: cfg.after_add, refresh: function () { self.render(); } });
    });
    this.render();
  }
  Cams.prototype.items = function () {
    var items = [], card = this.cards[this.sel];
    var vid = card && +card.getAttribute('data-variant-id');
    if (vid) items.push({ id: vid, quantity: 1 });
    this.accs.forEach(function (a) {
      var cb = $('input', a), id = +a.getAttribute('data-variant-id');
      if (cb && cb.checked && id) items.push({ id: id, quantity: 1 });
    });
    return items;
  };
  Cams.prototype.render = function () {
    var self = this, known = 0, unknown = false;
    this.cards.forEach(function (c, i) { c.setAttribute('aria-pressed', i === self.sel ? 'true' : 'false'); });
    var card = this.cards[this.sel];
    if (card) { var p = card.getAttribute('data-price'); if (p) known += +p; else unknown = true; }
    this.accs.forEach(function (a) {
      var cb = $('input', a);
      if (cb && cb.checked) { var p = a.getAttribute('data-price'); if (p) known += +p; else unknown = true; }
    });
    var ph = this.cfg.price_placeholder || '[PRICE]';
    var total = unknown ? (known ? W.money(known) + ' + ' + ph : ph) : W.money(known);
    if (this.atc) {
      this.atc.textContent = tpl(this.cfg.atc_label, { total: total });
      this.atc.disabled = unknown || !this.items().length;
    }
  };

  /* =====================================================================
     BUY AGAIN (dark) — mirrors the buy box tiers
     ===================================================================== */
  function Again(root) {
    var cfg = readJSON($('[data-whlp-again-config]', root)) || {};
    var grid = $('[data-whlp-again-tiers]', root), sum = $('[data-whlp-again-summary]', root),
      btn = $('[data-whlp-again-atc]', root), ship = $('[data-whlp-again-ship]', root);
    if (grid) grid.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tier]');
      if (b && W.buy) W.buy.select(+b.getAttribute('data-tier'));
    });
    if (btn) btn.addEventListener('click', function () { if (W.buy) W.buy.add(W.buy.cfg.after_add || 'drawer', btn); });
    function paint(s) {
      if (!s) return;
      if (sum) {
        var tn = s.tierName ? s.tierName.charAt(0) + s.tierName.slice(1).toLowerCase() : '';
        var txt = tpl(cfg.summary_tpl, { tier: tn, bags: s.bags, dust: s.dust, camera: s.camera ? tpl(cfg.camera_tpl || ' + [camera]', { camera: s.camera }) : '' });
        /* drop segments that came out empty (e.g. a tier with no Dust option) */
        sum.textContent = txt.split('·').map(function (x) { return x.trim(); }).filter(function (x) { return x.replace(/\bdust\b/i, '').replace(/\+/g, '').trim(); }).join(' · ');
      }
      if (grid) {
        grid.style.setProperty('--whlp-cols', s.tiers.length);
        grid.innerHTML = s.tiers.map(function (t) {
          return '<button type="button" class="whlp-again__tier" data-tier="' + t.idx + '" aria-pressed="' + (t.on ? 'true' : 'false') + '">' +
            '<span class="whlp-again__name">' + esc(t.name) + '</span><span class="whlp-again__price">' + esc(t.price) + '</span></button>';
        }).join('');
      }
      if (btn) { btn.disabled = !s.available; btn.textContent = tpl(cfg.atc_label, { total: s.total }); }
      if (ship) ship.textContent = s.ship;
    }
    document.addEventListener('whlp:change', function (e) { paint(e.detail); });
    if (W.buy) paint(W.buy.state);
  }

  /* ---------- boot ---------- */
  function boot(scope) {
    var s = scope || document;
    var cfgEl = document.querySelector('[data-whlp-globals]');
    var g = readJSON(cfgEl) || {};
    W.moneyFormat = g.money_format || W.moneyFormat; W.routes = g.routes || W.routes; W.currency = g.currency || W.currency; W.country = g.country || W.country;
    $$('[data-whlp-hero]', s).forEach(function (r) { W.applyDoor(r, r.getAttribute('data-door-param')); initGallery(r); });
    $$('[data-whlp-door-scope]', s).forEach(function (r) { W.applyDoor(r, r.getAttribute('data-door-param')); });
    $$('[data-whlp-buy]', s).forEach(function (r) { new Buy(r); });
    $$('[data-whlp-singles]', s).forEach(function (r) { new Singles(r); });
    $$('[data-whlp-cams]', s).forEach(function (r) { new Cams(r); });
    $$('[data-whlp-again]', s).forEach(function (r) { new Again(r); });
  }
  W.boot = boot;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  /* theme editor: re-init a section when it reloads */
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
    if (!e.target.querySelector('[data-whlp-buy]') && W.buy) W.buy.render();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var tier = e.target.closest && e.target.closest('[data-whlp-tier]');
    if (tier && W.buy) W.buy.select(+tier.getAttribute('data-idx'));
  });
})();
